// import React from 'react';
// import { Card, CardHeader, Heading, CardBody, useColorModeValue } from '@chakra-ui/react';
// import ReactApexChart from 'react-apexcharts';

// const CitySalesChart = ({ data, height = 400, title = 'City-wise Sales Analysis' }) => {
//    // Color mode values - must be at top before any conditionals
//    const textColor = useColorModeValue('#4A5568', '#E2E8F0');
//    const gridColor = useColorModeValue('#E2E8F0', '#2D3748');
//    const tooltipBg = useColorModeValue('#FFFFFF', '#2D3748');
//    const defaultBarColor = useColorModeValue('#3182CE', '#63B3ED');
//    const unknownCityColor = useColorModeValue('#CBD5E0', '#718096');
//    const lineColor = useColorModeValue('#38A169', '#68D391');
//    const dataLabelColor = useColorModeValue('#FFFFFF', '#1A202C');
//    const dataLabelBg = useColorModeValue('#3182CE', '#63B3ED');
//    const tooltipTheme = useColorModeValue('light', 'dark');

//    if (!data || data.length === 0) return null;

//    const categories = data.map((item) => item.regionname);
//    const totalSales = data.map((item) => item.total_sales);
//    const salesPercentages = data.map((item) => parseFloat(item.sales_contribution_percentage));

//    const barColors = data.map((item) => (item.regionname === 'Unknown City' ? unknownCityColor : defaultBarColor));

//    const options = {
//       chart: {
//          height,
//          type: 'line',
//          toolbar: { show: false },
//          zoom: { enabled: false },
//          foreColor: textColor,
//          background: 'transparent',
//       },
//       stroke: {
//          width: [0, 4],
//          curve: 'smooth',
//       },
//       plotOptions: {
//          bar: {
//             columnWidth: '50%',
//             distributed: true,
//             borderRadius: 6,
//          },
//       },
//       colors: [...barColors, lineColor], // Bar colors + line color
//       dataLabels: {
//          enabled: true,
//          enabledOnSeries: [0],
//          formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
//          style: {
//             fontSize: '12px',
//             colors: [dataLabelColor],
//             fontWeight: 'bold',
//          },
//          background: {
//             enabled: true,
//             foreColor: dataLabelBg,
//             padding: 4,
//             borderRadius: 4,
//             borderWidth: 0,
//             opacity: 0.9,
//             dropShadow: {
//                enabled: false,
//             },
//          },
//       },
//       markers: {
//          size: 6,
//          strokeWidth: 2,
//          strokeColors: tooltipBg,
//          hover: { size: 8 },
//       },
//       xaxis: {
//          categories,
//          labels: {
//             rotate: -45,
//             style: {
//                fontSize: '12px',
//                colors: textColor,
//             },
//          },
//          title: {
//             text: 'City',
//             style: {
//                color: textColor,
//             },
//          },
//          axisBorder: {
//             show: true,
//             color: gridColor,
//          },
//          axisTicks: {
//             color: gridColor,
//          },
//       },
//       yaxis: [
//          {
//             title: {
//                text: 'Total Sales (₹)',
//                style: {
//                   color: textColor,
//                },
//             },
//             labels: {
//                formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
//                style: {
//                   colors: textColor,
//                },
//             },
//             axisBorder: {
//                show: true,
//                color: gridColor,
//             },
//          },
//          {
//             opposite: true,
//             max: 100,
//             min: 0,
//             title: {
//                text: 'Sales %',
//                style: {
//                   color: textColor,
//                },
//             },
//             labels: {
//                formatter: (val) => `${val}%`,
//                style: {
//                   colors: textColor,
//                },
//             },
//          },
//       ],
//       grid: {
//          borderColor: gridColor,
//          strokeDashArray: 4,
//       },
//       tooltip: {
//          shared: true,
//          intersect: false,
//          theme: tooltipTheme,
//          y: [
//             {
//                formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
//             },
//             {
//                formatter: (val) => `${val}%`,
//             },
//          ],
//       },
//       legend: {
//          show: true,
//          position: 'top',
//          labels: { colors: textColor },
//          markers: {
//             width: 12,
//             height: 12,
//             radius: 12,
//          },
//          itemMargin: { horizontal: 10, vertical: 5 },
//       },
//    };

//    const series = [
//       {
//          name: 'Total Sales',
//          type: 'bar',
//          data: totalSales,
//       },
//       {
//          name: 'Sales Contribution %',
//          type: 'line',
//          data: salesPercentages,
//       },
//    ];

//    return (
//       <Card h={height + 80} minHeight={440}>
//          <CardHeader>
//             <Heading size="md">{title}</Heading>
//          </CardHeader>
//          <CardBody>
//             <ReactApexChart options={options} series={series} type="line" height={height} />
//          </CardBody>
//       </Card>
//    );
// };

// export default CitySalesChart;

import React, { useState } from 'react';
import { useColorMode } from '@chakra-ui/react';
import ReactApexChart from 'react-apexcharts';
import { TrendingUp, MapPin } from 'lucide-react';
import { RotateCw } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { getCityWiseSales } from '../../../../redux/actions/dashboard';

const CitySalesChart = ({
   data,
   height = 400,
   title = 'City-wise Sales Analysis',
   financialAnalysisDateRange,
   user,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isRotating, setIsRotating] = useState(false);
   const dispatch = useDispatch();

   // Color mode values
   const textColor = isDark ? '#E2E8F0' : '#4A5568';
   const gridColor = isDark ? '#2D3748' : '#E2E8F0';
   const tooltipBg = isDark ? '#2D3748' : '#FFFFFF';
   const defaultBarColor = isDark ? '#63B3ED' : '#3182CE';
   const unknownCityColor = isDark ? '#718096' : '#CBD5E0';
   const lineColor = isDark ? '#68D391' : '#38A169';
   const dataLabelColor = isDark ? '#1A202C' : '#FFFFFF';
   const dataLabelBg = isDark ? '#63B3ED' : '#3182CE';
   const tooltipTheme = isDark ? 'dark' : 'light';

   if (!data || data.length === 0) {
      return (
         <div
            className={`rounded-xl shadow-lg border ${
               isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
            }`}
            style={{ height: `${height + 80}px`, minHeight: '440px' }}>
            <div className="flex items-center justify-center h-full">
               <div className={`text-center ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  <MapPin className="w-12 h-12 mx-auto mb-3 opacity-50" />
                  <p className="text-sm font-medium">No city data available</p>
               </div>
            </div>
         </div>
      );
   }

   const categories = data.map((item) => item.regionname);
   const totalSales = data.map((item) => item.total_sales);
   const salesPercentages = data.map((item) => parseFloat(item.sales_contribution_percentage));

   const barColors = data.map((item) => (item.regionname === 'Unknown City' ? unknownCityColor : defaultBarColor));

   const options = {
      chart: {
         height,
         type: 'line',
         toolbar: {
            show: true,
            tools: {
               download: true,
               selection: false,
               zoom: false,
               zoomin: false,
               zoomout: false,
               pan: false,
               reset: false,
            },
         },
         zoom: { enabled: false },
         foreColor: textColor,
         background: 'transparent',
      },
      stroke: {
         width: [0, 4],
         curve: 'smooth',
      },
      plotOptions: {
         bar: {
            columnWidth: '50%',
            distributed: true,
            borderRadius: 6,
         },
      },
      colors: [...barColors, lineColor],
      dataLabels: {
         enabled: true,
         enabledOnSeries: [0],
         formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
         style: {
            fontSize: '12px',
            colors: [dataLabelColor],
            fontWeight: 'bold',
         },
         background: {
            enabled: true,
            foreColor: dataLabelBg,
            padding: 4,
            borderRadius: 4,
            borderWidth: 0,
            opacity: 0.9,
            dropShadow: {
               enabled: false,
            },
         },
      },
      markers: {
         size: 6,
         strokeWidth: 2,
         strokeColors: tooltipBg,
         hover: { size: 8 },
      },
      xaxis: {
         categories,
         labels: {
            rotate: -45,
            style: {
               fontSize: '12px',
               colors: textColor,
            },
         },
         title: {
            text: 'City',
            style: {
               color: textColor,
            },
         },
         axisBorder: {
            show: true,
            color: gridColor,
         },
         axisTicks: {
            color: gridColor,
         },
      },
      yaxis: [
         {
            title: {
               text: 'Total Sales (₹)',
               style: {
                  color: textColor,
               },
            },
            labels: {
               formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
               style: {
                  colors: textColor,
               },
            },
            axisBorder: {
               show: true,
               color: gridColor,
            },
         },
         {
            opposite: true,
            max: 100,
            min: 0,
            title: {
               text: 'Sales %',
               style: {
                  color: textColor,
               },
            },
            labels: {
               formatter: (val) => `${val.toFixed(2)}%`,
               style: {
                  colors: textColor,
               },
            },
         },
      ],
      grid: {
         borderColor: gridColor,
         strokeDashArray: 4,
      },
      tooltip: {
         shared: true,
         intersect: false,
         theme: tooltipTheme,
         y: [
            {
               formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
            },
            {
               formatter: (val) => `${val.toFixed(2)}%`,
            },
         ],
      },
      legend: {
         show: true,
         position: 'top',
         labels: { colors: textColor },
         markers: {
            width: 12,
            height: 12,
            radius: 12,
         },
         itemMargin: { horizontal: 10, vertical: 5 },
      },
   };

   const series = [
      {
         name: 'Total Sales',
         type: 'bar',
         data: totalSales,
      },
      {
         name: 'Sales Contribution %',
         type: 'line',
         data: salesPercentages,
      },
   ];

   // Calculate total sales for summary
   const totalSalesSum = totalSales.reduce((acc, val) => acc + val, 0);
   const topCity = data.reduce((max, city) => (city.total_sales > max.total_sales ? city : max), data[0]);

   const handleReload = async () => {
      setIsRotating(true);
      dispatch(
         getCityWiseSales({
            companyId: user?.loginhistory?.companyId,
            fromDate: financialAnalysisDateRange.fromDate,
            toDate: financialAnalysisDateRange.toDate,
         }),
      );
      setTimeout(() => setIsRotating(false), 700);
   };

   return (
      <div
         className={`rounded-xl shadow-lg border transition-all duration-300 ${
            isDark
               ? 'bg-gradient-to-br from-gray-800 to-gray-900 border-gray-700'
               : 'bg-gradient-to-br from-white to-blue-50/30 border-gray-200'
         }`}
         style={{ height: `${height + 80}px`, minHeight: '440px' }}>
         {/* Header with Stats */}
         <div className={`px-6 py-4 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
            <div className="flex items-center justify-between flex-wrap gap-4">
               <div className="flex items-center gap-3">
                  <div
                     className={`p-2 rounded-lg ${
                        isDark ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-500/10 text-blue-600'
                     }`}>
                     <MapPin className="w-5 h-5" />
                  </div>
                  <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>{title}</h2>
               </div>

               <div className="flex items-center gap-4">
                  <div
                     className={`px-4 py-2 rounded-lg border ${
                        isDark ? 'bg-gray-700/50 border-gray-600' : 'bg-white border-gray-200'
                     }`}>
                     <div className={`text-xs font-medium mb-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        Total Sales
                     </div>
                     <div className={`text-lg font-bold ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                        ₹{totalSalesSum.toLocaleString('en-IN')}
                     </div>
                  </div>

                  <div
                     className={`px-4 py-2 rounded-lg border ${
                        isDark ? 'bg-gray-700/50 border-gray-600' : 'bg-white border-gray-200'
                     }`}>
                     <div
                        className={`text-xs font-medium mb-1 flex items-center gap-1 ${
                           isDark ? 'text-gray-400' : 'text-gray-500'
                        }`}>
                        <TrendingUp className="w-3 h-3" />
                        Top City
                     </div>
                     <div className={`text-sm font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                        {topCity.regionname}
                     </div>
                  </div>

                  <button
                     onClick={handleReload}
                     className={`ml-auto p-2 rounded-full transition-all hover:scale-110 ${
                        isDark ? 'hover:bg-gray-600 text-blue-400' : 'hover:bg-gray-100 text-blue-600'
                     }`}>
                     <RotateCw
                        className={`w-5 h-5 transform ${
                           isRotating ? 'rotate-[360deg]' : ''
                        } transition-transform ease-in-out`}
                        style={{
                           transitionDuration: isRotating ? '700ms' : '10ms',
                        }}
                     />
                  </button>
               </div>
            </div>
         </div>

         {/* Chart Body */}
         <div className="p-6">
            <ReactApexChart options={options} series={series} type="line" height={height} />
         </div>
      </div>
   );
};

export default CitySalesChart;
